import { useTranslation } from "react-i18next";
import { dispatchMetadataEvent, endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { useCanvasMetadata } from "../../lib/schedule-art/canvas-state";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { ArtCreditInput } from "../editor-panel/art-section/ArtCreditLine";
import { GlobalElementPlacementControls } from "./GlobalElementPlacementControls";
import { TextStyleControls } from "./TextStyleControls";

export function ArtistCreditStep() {
  const { t } = useTranslation();
  const metadata = useCanvasMetadata();
  const sampleText = useMetadataBuilderStore(state => state.sampleArtistHandle);
  const setSampleText = useMetadataBuilderStore(state => state.setSampleArtistHandle);
  const index = metadata.globals.findIndex(element => element.bind === "profile.artist_handle");
  const credit = metadata.globals[index];
  if (!credit) return null;
  return (
    <div className="space-y-3" onBlurCapture={endMetadataMerge}>
      <div onFocusCapture={endMetadataMerge}>
        <ArtCreditInput handle={sampleText} onChange={setSampleText} onBlur={endMetadataMerge} />
        <p className="text-neutral-500">{t("builder.credit.sampleHelp")}</p>
      </div>
      <GlobalElementPlacementControls position={credit.position} rotation={credit.rotation} index={index} onUpdate={dispatchMetadataEvent} />
      <TextStyleControls styleName={credit.style} />
    </div>
  );
}
